import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Shield, ArrowRight } from "lucide-react";

const ATF_LOGO_FULL = "/logo.png";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "How We Work", to: "/how-we-work" },
  { label: "Services", to: "/services" },
  { label: "About ATF", to: "/about" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

const services = [
  "Elite Security Force",
  "Facility Operations",
  "Event & Crowd Management",
  "Special Task Force",
  "Workforce Deployment",
];

export default function Footer() {
  return (
    <footer className="bg-[#141414] text-[#F9F8F5] pt-24 pb-12 border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-24">
          {/* Col 1: Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-4 mb-8 group">
              <div className="w-16 h-16 transition-all">
                <img src={ATF_LOGO_FULL} alt="ASTRAUM TASK FORCE" className="w-full h-full object-contain filter drop-shadow-lg" />
              </div>
              <div>
                <span className="font-sans font-extrabold text-lg tracking-widest text-[#F9F8F5] block">ASTRAUM</span>
                <span className="font-sans text-[10px] font-bold tracking-[0.2em] text-[#835F21] uppercase block">Task Force</span>
              </div>
            </Link>
            <p className="font-sans text-base text-white/50 leading-relaxed mb-8 max-w-xs">
              India's premier mission-critical workforce deployment and security solutions company. Built on discipline, forged in precision.
            </p>
            <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-full px-5 py-2 w-fit">
              <Shield size={14} className="text-[#835F21]" />
              <span className="font-sans text-[10px] font-bold tracking-widest text-white/70 uppercase">PSARA Licensed</span>
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <h4 className="font-sans text-[10px] font-bold tracking-[0.3em] uppercase text-[#835F21] mb-8">
              Navigation
            </h4>
            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-sans text-sm font-medium text-white/50 hover:text-[#835F21] transition-colors flex items-center group"
                  >
                    <ArrowRight size={14} className="mr-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Services */}
          <div>
            <h4 className="font-sans text-[10px] font-bold tracking-[0.3em] uppercase text-[#835F21] mb-8">
              Core Capabilities
            </h4>
            <ul className="space-y-4">
              {services.map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="font-sans text-sm font-medium text-white/50 hover:text-[#835F21] transition-colors"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Operations */}
          <div>
            <h4 className="font-sans text-[10px] font-bold tracking-[0.3em] uppercase text-[#835F21] mb-8">
              ATF Office
            </h4>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin size={18} className="text-[#835F21] mt-1 flex-shrink-0" />
                <span className="font-sans text-sm text-white/50 leading-relaxed font-medium">
                  Office #410, Naxtra By Kavyaratna, <br />
                  Sargasan Cross Road, Below The Fern Residency, <br />
                  Gandhinagar, Gujarat, India - 382421
                </span>
              </div>
              <div className="flex items-center gap-4">
                <Phone size={18} className="text-[#835F21] flex-shrink-0" />
                <span className="font-sans text-sm text-white/50 font-bold tracking-widest">+91 98089 83333</span>
              </div>
              <div className="flex items-start gap-4">
                <Mail size={18} className="text-[#835F21] flex-shrink-0 mt-1" />
                <div className="flex flex-col gap-1">
                  <a href="mailto:secure@atfsecure.com" className="font-sans text-sm text-white/50 font-medium hover:text-[#835F21] transition-colors">
                    secure@atfsecure.com
                  </a>
                  <a href="mailto:astrumholding@gmail.com" className="font-sans text-sm text-white/50 font-medium hover:text-[#835F21] transition-colors">
                    astrumholding@gmail.com
                  </a>
                </div>
              </div>
            </div>
            

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row items-center justify-center gap-8">
          <p className="font-sans text-xs text-white/20 uppercase tracking-widest">
            © {new Date().getFullYear()} ASTRAUM TASK FORCE. ALL RIGHTS RESERVED.
          </p>
         
        </div>
      </div>
    </footer>
  );
}
